{
  "archived_Desc_Key": "Ytterligare hjälp finns här",
  "archived_Redirection_Key": "kundservice/Kontakta oss/",
  "archived_Title_Key": "Detta dokument har arkiverats.",
  "carousel_Text_Key": "Var artikeln inte till hjälp? Prova någon av de relaterade artiklarna nedan.",
  "clear_button_label_Text_Key": "Rensa sökfältet",
  "click_prompt_Text_Key": "här",
  "close_Text_Key": "Stäng",
  "customerService_Text_Key": "Kundtjänst",
  "error_Text_Key": "Något gick fel",
  "faq": "Vanliga frågor och svar",
  "feedback_Option1_Text_Key": "Texten är svår att förstå.",
  "feedback_Option2_Text_Key": "Texten är inte relevant för min fråga.",
  "feedback_Option3_Text_Key": "Texten är relevant men inte till någon hjälp.",
  "feedback_Option4_Text_Key": "Texten är för lång eller för kort.",
  "feedback_Question_1_Text_Key": "Vilka delar av våra artiklar tycker du är otillfredsställande eller oanvändbara?",
  "feedback_Rec_Text_Key": "Tack för din feedback!",
  "feedback_Text_Key": "Tyckte du att detta var användbart?",
  "here_Text_Key": "här",
  "knowledge_Text_Key": "Kunskap",
  "link_prod_error_Text_Key": "https://ikea.marat.qd.je/gb/en/customer-service/track-manage-order/",
  "loading_Text_Key": "Laddar",
  "market_Name_Key": "Finland",
  "modal_button_Close_Text_Key": "Stäng",
  "negative_feedback_Text_Key": "Vi beklagar att du inte fick det svar du sökte. Vill du hjälpa oss att förbättra oss?",
  "no_results_Text_Key": "Vi hittade inga träffar för söktermen: {{query}}",
  "product_error_Text_Key": "Tyvärr, inga resultat hittades. Denna sökmotor stöder endast ett eller flera nyckelord. Om du vill ha information om våra produkter, använd huvudsakliga sökmotorn som finns högst upp på webbplatsen. Om du vill kontrollera statusen för din beställning, klicka här.",
  "read_more_button_Text_Key": "Läs mer",
  "results_Text_Key": "Vi hittade {{number}} resultat för: {{query}}",
  "retrieving_Text_Key": "Hämta",
  "search_button_label_Text_Key": "Sök",
  "searchbar_Text_Key": "Skriv ett ord eller en fras, till exempel beställ eller ändra.",
  "searching_Text_Key": "Söker...",
  "showLess_Text_Key": "Visa mindre",
  "showMore_Text_Key": "Visa mer",
  "spellcheck_Text_Key": "Kontrollera stavningen eller använd andra sökord.",
  "submit_Text_Key": "Skicka",
  "try_again_Text_Key": "Försök igen senare"
}